module.exports = __webpack_public_path__ + "static/media/glenarc-small.1aed37e6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/res/glenarc-small.mp4
// module id = 448
// module chunks = 0